import { useStore } from 'effector-react'
import * as React from 'react'

import { $exchanger, exchangerMounted, getExchanger } from './model'

export const useExchanger = () => {
  const exchanger = useStore($exchanger)

  const loading = useStore(getExchanger.pending)

  React.useEffect(() => {
    exchangerMounted()
  }, [])

  return { exchanger, loading }
}
